import serverManagement from './service';
export default {
    serverManagement
};